var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarksStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.09 42.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6e6e6;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "marks-star") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.21.49l4.84,14.89a.72.72,0,0,0,.67.49H44.39a.7.7,0,0,1,.41,1.27L32.13,26.35a.7.7,0,0,0-.26.78L36.71,42a.7.7,0,0,1-1.08.79L23,33.61a.71.71,0,0,0-.83,0L9.46,42.82A.7.7,0,0,1,8.38,42l4.84-14.9a.7.7,0,0,0-.26-.78L.29,17.14A.7.7,0,0,1,.7,15.87H16.37a.72.72,0,0,0,.67-.49L21.88.49A.7.7,0,0,1,23.21.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarksStar);
export default __webpack_public_path__ + "static/media/marks-star.0b4976e9fa8a42fe0ffb4f15a442a071.svg";
export { ForwardRef as ReactComponent };